// Cart quantity bridge for Clash Studios custom theme
// Dawn 15.4.1's cart-items.onChange only validates — this bridges to updateQuantity
(function() {
  var debounceTimer;
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.classList.contains('quantity__input')) return;
    
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      var cartItems = document.querySelector('cart-items');
      if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;
      
      var line = input.dataset.index;
      var quantity = parseInt(input.value);
      var name = input.name;
      var variantId = input.dataset.quantityVariantId;
      
      if (isNaN(quantity) || quantity < 0) return;
      cartItems.updateQuantity(line, quantity, e, name, variantId);
    }, 300);
  });
})();
